export class FieldsPrerequisite {
    countryCode: string;
    multipleAddresses: boolean;
    formModuleTitle: string;
    ampError: boolean;
    formModuleId: string;
    memberTypeId: string;
    employmentCountryCode: string;
}
